export default "__VITE_ASSET__Bgu6R$E___"